/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ExternalValueModel } from './ExternalValueModel';
import type { ValuationApproachBacksolve } from './ValuationApproachBacksolve';
import type { ValuationApproachDCF } from './ValuationApproachDCF';
import type { ValuationApproachFutureExit } from './ValuationApproachFutureExit';
import type { ValuationApproachGPC } from './ValuationApproachGPC';
import type { ValuationApproachGPT } from './ValuationApproachGPT';
import type { ValuationApproachSSV } from './ValuationApproachSSV';
import type { ValuationApproachWeightModel } from './ValuationApproachWeightModel';
export type ValuationApproachDependency = {
  readonly id?: number;
  approach_type: ValuationApproachDependency.approach_type;
  valuations_approach_gpc?: ValuationApproachGPC;
  valuations_approach_gpt?: ValuationApproachGPT;
  valuations_approach_ev?: ExternalValueModel;
  valuations_approach_dcf?: ValuationApproachDCF;
  valuations_approach_backsolve?: ValuationApproachBacksolve;
  valuations_approach_ssv?: ValuationApproachSSV;
  valuations_approach_future_exit?: ValuationApproachFutureExit;
  readonly valuations_approaches_weights?: Array<ValuationApproachWeightModel>;
  valuation?: number;
  financial_statement?: number | null;
  panel_id: string;
  readonly reference_for_sibling?: string;
  readonly is_weighted?: string;
  name: string;
  readonly last_audit_event_id?: string | null;
  is_deleted?: boolean | null;
  readonly deleted_at?: string | null;
  equity_value?: string | null;
  enterprise_value?: string | null;
  valuation_date?: string | null;
  is_calibration?: boolean;
};
export namespace ValuationApproachDependency {
  export enum approach_type {
    EXTERNAL_VALUATION = 'External Valuation',
    PUBLIC_COMPS = 'Public Comps',
    DISCOUNTED_CASH_FLOW = 'Discounted Cash Flow',
    TRANSACTION_COMPS = 'Transaction Comps',
    BACKSOLVE = 'Backsolve',
    FUTURE_EXIT = 'Future Exit',
    SPECIFIED_SHARE_VALUES = 'Specified Share Values',
  }
}

